import { TextField } from "@mui/material";
import type { ReactNode } from "react";
import { useFilterDropdown } from "../hooks/useFilterDropdown";

type FilterSelectProps = {
  children: ReactNode;
  className?: string;
  displayEmpty?: boolean;
  label: ReactNode;
  renderValue?: (value: string) => ReactNode;
  size?: "small" | "medium";
  startAdornment?: ReactNode;
  value: string;
  onChange: (value: string) => void;
};

export function FilterSelect({
  children,
  className,
  displayEmpty = false,
  label,
  renderValue,
  size = "small",
  startAdornment,
  value,
  onChange,
}: FilterSelectProps) {
  const dropdown = useFilterDropdown();

  return (
    <TextField
      select
      className={className}
      size={size}
      label={label}
      value={value}
      slotProps={{
        input: { startAdornment },
        inputLabel: { shrink: true },
        select: {
          displayEmpty,
          open: dropdown.open,
          onOpen: dropdown.onOpen,
          onClose: dropdown.onClose,
          MenuProps: dropdown.MenuProps,
          renderValue: renderValue ? (selected) => renderValue(String(selected || "")) : undefined,
        },
      }}
      onChange={(event) => onChange(String(event.target.value))}
    >
      {children}
    </TextField>
  );
}
